import jsonFormatAuth from "../../apis/jsonFormatAuth";

export const retryCeleryStatus = ({ axiosFetch, celeryTaskId }) => {
  // Only call getCeleryStatus() after 500 ms
  const celeryStatusHandlerTimer = setTimeout(() => {
    getCeleryStatus({ axiosFetch, celeryTaskId: celeryTaskId });
  }, 500);

  return () => {
    clearTimeout(celeryStatusHandlerTimer);
  };
};

export const getCeleryStatus = ({ axiosFetch, celeryTaskId }) => {
  //   console.log("Asking celery for status of task.");
  axiosFetch({
    axiosInstance: jsonFormatAuth(),
    method: "GET",
    url: `celery-progress/${celeryTaskId}/`,
    sendSignal: false,
    requestConfig: {},
  });
};
